export default "__VITE_ASSET__nEGd0NXH__"